/* eslint-disable no-shadow */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GetDataSources = '[DataSourceState] GetDataSources',
  GetDataSourcesSuccessful = '[DataSourceState] GetDataSourcesSuccessful',
  GetDataSourcesFailure = '[DataSourceState] GetDataSourcesFailure',
  ResetDataSource = '[DataSourceState] ResetDataSource',
  ResetDataSourceSuccessful = '[DataSourceState] ResetDataSourceSuccessful',
  ResetDataSourceFailure = '[DataSourceState] ResetDataSourceFailure',
  UpdateDataSource = '[DataSourceState] UpdateDataSource',
  UpdateDataSourceSuccessful = '[DataSourceState] UpdateDataSourceSuccessful',
  UpdateDataSourceFailure = '[DataSourceState] UpdateDataSourceFailure'
}

export const GetDataSources = createAction(
  ActionTypes.GetDataSources
);

export const GetDataSourcesSuccessful = createAction(
  ActionTypes.GetDataSourcesSuccessful,
  props<{ payload: { datasources: any } }>()
);

export const GetDataSourcesFailure = createAction(
  ActionTypes.GetDataSourcesFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const ResetDataSource = createAction(
  ActionTypes.ResetDataSource,
  props<{ payload: { id: any } }>()
);

export const ResetDataSourceSuccessful = createAction(
  ActionTypes.ResetDataSourceSuccessful
);

export const ResetDataSourceFailure = createAction(
  ActionTypes.ResetDataSourceFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const UpdateDataSource = createAction(
  ActionTypes.UpdateDataSource,
  props<{ payload: { id: any; body: any } }>()
);

export const UpdateDataSourceSuccessful = createAction(
  ActionTypes.UpdateDataSourceSuccessful
);

export const UpdateDataSourceFailure = createAction(
  ActionTypes.UpdateDataSourceFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);
